import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../../src/functions/useLanguage';
import { wt } from '../i18n';

interface FAQItem {
  id: string;
  categoryKey: string;
  questionKey: string;
  answerKey: string;
}

const FAQ_ITEMS: FAQItem[] = [
  // Getting Started
  { id: 'gs-1', categoryKey: 'faq.category.gettingStarted', questionKey: 'faq.q.whatIsKodaCare', answerKey: 'faq.a.whatIsKodaCare' },
  { id: 'gs-2', categoryKey: 'faq.category.gettingStarted', questionKey: 'faq.q.whoCanUse', answerKey: 'faq.a.whoCanUse' },
  { id: 'gs-3', categoryKey: 'faq.category.gettingStarted', questionKey: 'faq.q.howToSignUp', answerKey: 'faq.a.howToSignUp' },
  { id: 'gs-4', categoryKey: 'faq.category.gettingStarted', questionKey: 'faq.q.techSkills', answerKey: 'faq.a.techSkills' },

  // Vitals Logbook
  { id: 'vl-1', categoryKey: 'faq.category.vitals', questionKey: 'faq.q.whatAreVitals', answerKey: 'faq.a.whatAreVitals' },
  { id: 'vl-2', categoryKey: 'faq.category.vitals', questionKey: 'faq.q.howOftenLog', answerKey: 'faq.a.howOftenLog' },
  { id: 'vl-3', categoryKey: 'faq.category.vitals', questionKey: 'faq.q.normalRanges', answerKey: 'faq.a.normalRanges' },
  { id: 'vl-4', categoryKey: 'faq.category.vitals', questionKey: 'faq.q.fluidIntake', answerKey: 'faq.a.fluidIntake' },
  { id: 'vl-5', categoryKey: 'faq.category.vitals', questionKey: 'faq.q.editDeleteLogs', answerKey: 'faq.a.editDeleteLogs' },

  // Medication Centre
  { id: 'mc-1', categoryKey: 'faq.category.meds', questionKey: 'faq.q.addMedication', answerKey: 'faq.a.addMedication' },
  { id: 'mc-2', categoryKey: 'faq.category.meds', questionKey: 'faq.q.immunosuppressants', answerKey: 'faq.a.immunosuppressants' },
  { id: 'mc-3', categoryKey: 'faq.category.meds', questionKey: 'faq.q.reminders', answerKey: 'faq.a.reminders' },
  { id: 'mc-4', categoryKey: 'faq.category.meds', questionKey: 'faq.q.missedDose', answerKey: 'faq.a.missedDose' },
  { id: 'mc-5', categoryKey: 'faq.category.meds', questionKey: 'faq.q.multipleUsers', answerKey: 'faq.a.multipleUsers' },

  // Digital Guide
  { id: 'dg-1', categoryKey: 'faq.category.guide', questionKey: 'faq.q.whatInGuide', answerKey: 'faq.a.whatInGuide' },
  { id: 'dg-2', categoryKey: 'faq.category.guide', questionKey: 'faq.q.languages', answerKey: 'faq.a.languages' },
  { id: 'dg-3', categoryKey: 'faq.category.guide', questionKey: 'faq.q.guideAccuracy', answerKey: 'faq.a.guideAccuracy' },
  { id: 'dg-4', categoryKey: 'faq.category.guide', questionKey: 'faq.q.updateGuide', answerKey: 'faq.a.updateGuide' },

  // Notifications & Rewards
  { id: 'nr-1', categoryKey: 'faq.category.notifications', questionKey: 'faq.q.notificationTypes', answerKey: 'faq.a.notificationTypes' },
  { id: 'nr-2', categoryKey: 'faq.category.notifications', questionKey: 'faq.q.customizeNotifications', answerKey: 'faq.a.customizeNotifications' },
  { id: 'nr-3', categoryKey: 'faq.category.notifications', questionKey: 'faq.q.twoNotifications', answerKey: 'faq.a.twoNotifications' },
  { id: 'nr-4', categoryKey: 'faq.category.notifications', questionKey: 'faq.q.whatIsKoda', answerKey: 'faq.a.whatIsKoda' },
  { id: 'nr-5', categoryKey: 'faq.category.notifications', questionKey: 'faq.q.earnXP', answerKey: 'faq.a.earnXP' },
  { id: 'nr-6', categoryKey: 'faq.category.notifications', questionKey: 'faq.q.streaks', answerKey: 'faq.a.streaks' },

  // Roomies & Community
  { id: 'rm-1', categoryKey: 'faq.category.roomies', questionKey: 'faq.q.whatAreRoomies', answerKey: 'faq.a.whatAreRoomies' },
  { id: 'rm-2', categoryKey: 'faq.category.roomies', questionKey: 'faq.q.joinRoomies', answerKey: 'faq.a.joinRoomies' },
  { id: 'rm-3', categoryKey: 'faq.category.roomies', questionKey: 'faq.q.privacy', answerKey: 'faq.a.privacy' },
  { id: 'rm-4', categoryKey: 'faq.category.roomies', questionKey: 'faq.q.leaveRoomies', answerKey: 'faq.a.leaveRoomies' },

  // Trends & Data
  { id: 'td-1', categoryKey: 'faq.category.trends', questionKey: 'faq.q.whatAreTrends', answerKey: 'faq.a.whatAreTrends' },
  { id: 'td-2', categoryKey: 'faq.category.trends', questionKey: 'faq.q.shareData', answerKey: 'faq.a.shareData' },
  { id: 'td-3', categoryKey: 'faq.category.trends', questionKey: 'faq.q.dataDownload', answerKey: 'faq.a.dataDownload' },

  // Privacy & Security
  { id: 'ps-1', categoryKey: 'faq.category.security', questionKey: 'faq.q.dataEncrypted', answerKey: 'faq.a.dataEncrypted' },
  { id: 'ps-2', categoryKey: 'faq.category.security', questionKey: 'faq.q.whoAccess', answerKey: 'faq.a.whoAccess' },
  { id: 'ps-3', categoryKey: 'faq.category.security', questionKey: 'faq.q.compliance', answerKey: 'faq.a.compliance' },
  { id: 'ps-4', categoryKey: 'faq.category.security', questionKey: 'faq.q.deleteAccount', answerKey: 'faq.a.deleteAccount' },
  { id: 'ps-5', categoryKey: 'faq.category.security', questionKey: 'faq.q.dataRetention', answerKey: 'faq.a.dataRetention' },

  // Pricing & Features
  { id: 'pf-1', categoryKey: 'faq.category.pricing', questionKey: 'faq.q.freePlan', answerKey: 'faq.a.freePlan' },
  { id: 'pf-2', categoryKey: 'faq.category.pricing', questionKey: 'faq.q.planDifference', answerKey: 'faq.a.planDifference' },
  { id: 'pf-3', categoryKey: 'faq.category.pricing', questionKey: 'faq.q.upgrade', answerKey: 'faq.a.upgrade' },
  { id: 'pf-4', categoryKey: 'faq.category.pricing', questionKey: 'faq.q.refund', answerKey: 'faq.a.refund' },

  // Technical
  { id: 'ts-1', categoryKey: 'faq.category.technical', questionKey: 'faq.q.devices', answerKey: 'faq.a.devices' },
  { id: 'ts-2', categoryKey: 'faq.category.technical', questionKey: 'faq.q.offline', answerKey: 'faq.a.offline' },
  { id: 'ts-3', categoryKey: 'faq.category.technical', questionKey: 'faq.q.syncData', answerKey: 'faq.a.syncData' },
  { id: 'ts-4', categoryKey: 'faq.category.technical', questionKey: 'faq.q.support', answerKey: 'faq.a.support' },
];

function Accordion() {
  const { language } = useLanguage();
  const t = (key: Parameters<typeof wt>[1]) => wt(language, key);
  const [expandedId, setExpandedId] = useState<string | null>(null);

  // Group by category
  const categories = Array.from(
    new Map(
      FAQ_ITEMS.map(item => [item.categoryKey, { key: item.categoryKey, items: [] as FAQItem[] }])
    ).values()
  );
  FAQ_ITEMS.forEach(item => {
    const cat = categories.find(c => c.key === item.categoryKey);
    if (cat) cat.items.push(item);
  });

  return (
    <div className="space-y-8">
      {categories.map(category => (
        <div key={category.key}>
          <h3 className="text-lg font-bold text-gray-900 mb-4">{t(category.key as any)}</h3>
          <div className="space-y-2">
            {category.items.map(item => (
              <div
                key={item.id}
                className="border border-gray-200 rounded-lg overflow-hidden bg-white transition-shadow"
              >
                <button
                  onClick={() => setExpandedId(expandedId === item.id ? null : item.id)}
                  className="w-full px-6 py-4 flex items-start justify-between hover:bg-gray-50 transition-colors"
                >
                  <span className="text-left font-medium text-gray-900 text-sm sm:text-base">
                    {t(item.questionKey as any)}
                  </span>
                  <ChevronDown
                    size={20}
                    className={`shrink-0 ml-4 text-gray-600 transition-transform ${
                      expandedId === item.id ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                {expandedId === item.id && (
                  <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 text-sm text-gray-700 leading-relaxed">
                    {t(item.answerKey as any)}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export function FAQ() {
  const { language } = useLanguage();
  const t = (key: Parameters<typeof wt>[1]) => wt(language, key);

  useEffect(() => {
    const prev = document.title;
    const title = 'Frequently Asked Questions | KodaCare';
    const description = 'Answers to common questions about KodaCare — tracking pet health, managing medications, multi-carer plans, and more.';
    document.title = title;
    const setMeta = (selector: string, attr: string, content: string) => {
      let el = document.querySelector(selector) as HTMLMetaElement | null;
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, selector.match(/"([^"]+)"/)?.[1] ?? ''); document.head.appendChild(el); }
      el.content = content;
    };
    setMeta('meta[name="description"]', 'name', description);
    setMeta('meta[property="og:title"]', 'property', title);
    setMeta('meta[property="og:description"]', 'property', description);
    setMeta('meta[property="og:url"]', 'property', 'https://kodacare.pet/faq');
    setMeta('meta[property="og:image"]', 'property', 'https://kodacare.pet/icons/og-image.png');
    setMeta('meta[name="twitter:card"]', 'name', 'summary_large_image');
    setMeta('meta[name="twitter:title"]', 'name', title);
    setMeta('meta[name="twitter:description"]', 'name', description);
    setMeta('meta[name="twitter:image"]', 'name', 'https://kodacare.pet/icons/og-image.png');
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
    const prevCanonical = canonical.href;
    canonical.href = 'https://kodacare.pet/faq';
    return () => { document.title = prev; if (canonical) canonical.href = prevCanonical; };
  }, []);

  return (
    <main className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-gradient-to-br from-primary-brown/10 to-white py-16 sm:py-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <h1 className="text-4xl sm:text-5xl font-black text-gray-900 mb-4">
            {t('faq.heading')}
          </h1>
          <p className="text-lg sm:text-xl text-gray-600 max-w-2xl">
            {t('faq.subheading')}
          </p>
        </div>
      </div>

      {/* FAQ Content */}
      <div className="max-w-4xl mx-auto px-6 lg:px-10 py-16 sm:py-24">
        <Accordion />
      </div>

      {/* CTA Footer */}
      <div className="bg-gray-50 py-16 sm:py-24 border-t border-gray-200">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            {t('faq.stillHaveQuestions')}
          </h2>
          <p className="text-gray-600">
            {t('faq.contactUs')}
          </p>
        </div>
      </div>
    </main>
  );
}
